module.exports = __webpack_public_path__ + "static/media/1027921.087fd56e.png";